export const BULLET_PREFIX_PATTERN = /^\s*[*\-•]\s+/;
export const LINE_BREAK_PATTERN = /<br\s*\/?>|\n/i;
